import React, { useEffect, useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { Section, Reveal } from "@/components/primitives";
import { getContent, trackEvent } from "@/lib/api";

export default function Roadmap() {
  const [phases, setPhases] = useState([]);
  useEffect(() => {
    trackEvent("page_view", { page: "roadmap" });
    getContent("roadmap").then(setPhases).catch(() => {});
  }, []);

  return (
    <div>
      <PageHeader
        eyebrow="Roadmap"
        title="Build once. Learn continuously. Scale globally."
        sub="Our development direction. All items are planned and subject to development and regulatory considerations — nothing here is guaranteed."
      />

      <Section grid>
        <div className="hidden lg:block relative" data-testid="roadmap-horizontal">
          <div className="absolute top-[46px] left-0 right-0 h-px bg-gradient-to-r from-[#2DD4BF]/40 via-[#0E9E90]/40 to-transparent" />
          <div className="grid grid-cols-6 gap-4">
            {phases.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.08}>
                <div>
                  <div className="flex items-center justify-center">
                    <span className={`relative z-10 grid place-items-center h-6 w-6 rounded-full border-2 ${i === 0 ? "border-[#2DD4BF] bg-[#2DD4BF]/20" : "border-[#0E9E90] bg-[#030305]"}`}>
                      <span className={`h-2 w-2 rounded-full ${i === 0 ? "bg-[#2DD4BF]" : "bg-[#0E9E90]"}`} />
                    </span>
                  </div>
                  <div className="mt-6 rounded-xl border border-white/10 bg-[#0A0B10] p-5 h-full">
                    <p className="font-mono text-xs text-[#2DD4BF]">{p.phase}</p>
                    <h3 className="text-base font-bold text-white mt-2 leading-snug">{p.title}</h3>
                    <p className="text-xs text-[#94A3B8] mt-2 leading-relaxed">{p.desc}</p>
                    <span className={`inline-block mt-4 rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest ${p.status === "In Progress" ? "border-[#2DD4BF]/40 text-[#2DD4BF] bg-[#2DD4BF]/10" : "border-white/15 text-[#94A3B8]"}`}>
                      {p.status}
                    </span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* Mobile vertical */}
        <div className="lg:hidden space-y-4">
          {phases.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.05}>
              <div className="rounded-xl border border-white/10 bg-[#0A0B10] p-5">
                <div className="flex items-center justify-between">
                  <p className="font-mono text-xs text-[#2DD4BF]">{p.phase}</p>
                  <span className={`rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest ${p.status === "In Progress" ? "border-[#2DD4BF]/40 text-[#2DD4BF] bg-[#2DD4BF]/10" : "border-white/15 text-[#94A3B8]"}`}>
                    {p.status}
                  </span>
                </div>
                <h3 className="text-base font-bold text-white mt-2">{p.title}</h3>
                <p className="text-sm text-[#94A3B8] mt-2">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <p className="mt-10 text-center font-mono text-xs text-[#64748B]">
          Planned / subject to development and regulatory considerations.
        </p>
      </Section>
    </div>
  );
}
